module.exports = __webpack_public_path__ + "img/qualityFactors.61e363a.webp";